var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-section"},[_c('pre',[_vm._v(_vm._s(_vm.templateContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }